let lazyloadThrottleTimeout;
let lazyloadImages = document.querySelectorAll(".lazy-background,.lazy-image");

document.addEventListener("DOMContentLoaded", function() {
	if ("IntersectionObserver" in window) {
		var imageObserver = new IntersectionObserver(function(entries) {
			entries.forEach(function(entry) {
				if (!entry.isIntersecting) {
					return;
				}

				var image = entry.target;

				if (image.getAttribute('data-src')) {
					image.setAttribute('src', image.getAttribute('data-src'))
				}

				if (image.getAttribute('data-background')) {
					image.style.backgroundImage = 'url(' + image.getAttribute('data-background') + ')'
				}

				image.classList.add("loaded");
				image.classList.remove("lazy-image");
				//image.classList.remove("lazy-background");
				imageObserver.unobserve(image);
			});
		});

		lazyloadImages.forEach(function(image) {
			imageObserver.observe(image);
		});
	} else {
		document.addEventListener("scroll", lazyload);
		window.addEventListener("resize", lazyload);
		window.addEventListener("orientationChange", lazyload);
	}
})

function lazyload() {
	if (lazyloadThrottleTimeout) { 
		clearTimeout(lazyloadThrottleTimeout);
	}

	lazyloadThrottleTimeout = setTimeout(function() {
		var scrollTop = window.pageYOffset;
		lazyloadImages.forEach(function(image) {
			if (!image) {
				return;
			}

			if (image.offsetTop >= (window.innerHeight + scrollTop)) {
				return;
			}

			if (image.getAttribute('data-src')) {
				image.setAttribute('src', image.getAttribute('data-src'));
			}

			if (image.getAttribute('data-background')) {
				image.style.backgroundImage = 'url(' + image.getAttribute('data-background') + ')';
			}

			image.classList.add('loaded')
			image.classList.remove("lazy-image");
			//image.classList.remove("lazy-background");
		});

		lazyloadImages = document.querySelectorAll(".lazy-background:not(.loaded),.lazy-image:not(loaded)")

		if (lazyloadImages.length == 0) {
			document.removeEventListener("scroll", lazyload);
			window.removeEventListener("resize", lazyload);
			window.removeEventListener("orientationChange", lazyload);
		}
	}, 20);
}